export { addSearch } from './addSearch'
export * from './types'
export * from './SearchReactFeature'
export { getPreloadResource } from './preload'

export { SearchReactFeature as default } from './SearchReactFeature'
